import styled from "styled-components";
import Theme from "../../../../Styles/Themes";
import config from "../../../../Config/config.json"

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    gap: 5px;
    width: 100%;
`;

export const SideBarButton = styled.a`
    position:  relative;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 10px;
    color: #fff;
    background: transparent;
    border: none;
    outline: none;
    font-weight: 400;
    font-size: ${Theme[config.theme].font.labels['small'].size};
    line-height: ${Theme[config.theme].font.labels['small'].line_height};
    cursor: pointer;
    padding: 5px;
    width: 100%;
    white-space: nowrap;
    text-decoration: none;
    &:hover {
        font-weight: 700;
    }
    @media (min-width: 1281px) {
        font-size: ${Theme[config.theme].font.labels['small'].size};
        line-height: ${Theme[config.theme].font.labels['small'].line_height};
    }
`;

export const Circle = styled.div`
    position: absolute;
    width: 10px;
    height: 10px;
    border-radius: 5px;
    left: -15px;
    background: ${(props) => (props.$isHovered ? '#3E78AA' : '#9BA8C3')};
    border-radius: 9999px;
    z-index: 5;
`;

export const Line = styled.div`
    position: absolute;
    top: 28px;
    width: 36.5px; 
    height: 0px; 
    transform: rotate(270deg); 
    transform-origin: -5px 11px; 
    background: #9BA8C3;
    border: 1.50px #9BA8C3 solid; 
    zIndex: 1;
`;